import { useTranslation } from 'react-i18next'

import { DashboardBookingsSection } from './DashboardBookingsSection'

export function RequestsPage() {
  const { t } = useTranslation()
  return (
    <div className="h-full min-w-0">
      <h1 className="sr-only">{t('dashboard.pageTitle')}</h1>
      <DashboardBookingsSection />
    </div>
  )
}
